/**
 *
 * Asynchronously loads the component for AdmissionEnquiry
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const AdmissionEnquiry = lazyLoad(
  () => import('./index'),
  module => module.AdmissionEnquiry,
);
